import classNames from 'classnames'

const ArrowDownIcon = ({ className, ...props }) => {
  return (
    <svg
      {...props}
      className={classNames('arrow_down_icon', className)}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
    >
      <path d="M1 1L6 5L11 1" stroke="#17171C" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

export default ArrowDownIcon
